const TreeNode = require('../TreeNode');
const AICalc = require('../AICalc');

const Q_how_many_nearby_enemies_BASE = function (actor, battleState, altNode) {
  const node = new TreeNode(actor, battleState, altNode);

  // branch indexes
  node.ZERO = 0;

  node.calculateNearbyEnemies = function (defineNearby) {
    if (!battleState) {
      return 0;
    } else {
      let enemies = battleState.getEnemiesOfUnit(actor);
      if (actor.hero && !actor.poppet && !battleState.isCaverns) {
        enemies = enemies.filter(({ hero, poppet }) => hero && !poppet);
      }

      var nearbyEnemies = AICalc.getNearbyUnits(actor, enemies, defineNearby);
      return nearbyEnemies.length;
    }
  };

  return node;
};
module.exports = Q_how_many_nearby_enemies_BASE;
